import { Box, Container,  Typography, Tab } from '@mui/material'
import React, { useContext, useState, useEffect } from 'react'
import {LiaPlaneDepartureSolid} from 'react-icons/lia';
import {HiOutlineBuildingOffice2} from 'react-icons/hi2';
import {HiOutlineHomeModern} from 'react-icons/hi2';
import {PiParachuteFill,PiAirplaneInFlightThin} from 'react-icons/pi';
import {BsFillCloudsFill, BsCashCoin} from 'react-icons/bs';
import {IoIosTrain} from 'react-icons/io';
import {IoBusOutline} from 'react-icons/io5';
import {AiFillCar} from 'react-icons/ai';
import { NavLink, useNavigate } from 'react-router-dom';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { NavigatorContext } from '../../contexts/NavigatorContext';
import './appbar.css';


const navbar= {
    width: '65vw',
    height:'96px',
    backgroundColor: 'white',
    borderRadius: '6px',
    boxShadow: "4px 4px 6px #bbb",
    overflow:'hidden',
    position:'relative',
    zIndex: 2
    
}
const navbar2= {
    width: '80vw',
    height:'max-content',
    backgroundColor: 'white',
    borderRadius: '6px',
    boxShadow: "4px 4px 6px #bbb",
    position:'relative',
    zIndex: 2,
    display:'block',
    margin: '0 auto'
}
const texter = {
    textTransform: "none",
    fontSize: '12px',
    fontWeight:'bold',
    wordWrap: 'break-word',
    width: '7vw'
}
const texter2 =  {
    width: '15vw',
    textTransform: "none",
    fontSize: '12px',
    fontWeight:'bold',
    wordWrap: 'break-word',
}

function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
        }}
        {...props}
      />
    );
  }
  
export default function Appbar() {
    const [value, setValue] = useState("flight");
    const navigate = useNavigate();
    const {param, setParam} = useContext(NavigatorContext);
    const handleChange = (event, newValue)=> {
        setValue(newValue);
        setParam(newValue);
        navigate(`${newValue}s`);
        event.stopPropagation();
    }
    useEffect(()=>{
        setValue(param);
    }, [param])
    const widthClass = {
        width: '65vw',
        margin: "0 auto",
        zIndex: '2'
    }
    const handleMobNav = (e)=>{
        navigate(e.target.id)
    }
    return (
        <>
            <div style={widthClass} className='appbar-desk'>
            <Container
            sx={navbar}
            >
            <TabContext value={value} sx={navbar}>
            <Box 
            display='flex'
            sx={{ borderBottom: 1, borderColor:'white', width:"65vw", justifyContent:'space-evenly'}}>
                <TabList onChange={handleChange}
                sx={{width: '65vw'}}
                >
                    <LinkTab sx={texter} icon={<LiaPlaneDepartureSolid style={{fontSize:"40px"}}/>} label="Flights" value="flight" />
                    <LinkTab sx={texter} icon={<HiOutlineBuildingOffice2 style={{fontSize:"40px"}}/>} label="Hotels" value="hotel" />
                    <LinkTab sx={texter} icon={<HiOutlineHomeModern style={{fontSize:"40px"}}/>} label="Homestays" value="home" />
                    <LinkTab sx={texter} icon={<Box display='flex'><PiParachuteFill style={{fontSize:"40px"}}/><BsFillCloudsFill style={{fontSize:"30px"}}/></Box>} label="Holiday Packages" value="holiday" />
                    <LinkTab sx={texter} icon={<IoIosTrain style={{fontSize:"40px"}}/>} label="Trains" value="train" />
                    <LinkTab sx={texter} icon={<IoBusOutline style={{fontSize:"40px"}}/>} label="Buses" value="buse" />
                    <LinkTab sx={texter} icon={<AiFillCar style={{fontSize:"40px"}}/>} label="Cabs" value="cab" />
                    <LinkTab sx={texter} icon={<BsCashCoin style={{fontSize:"40px"}}/>} label="Forex" value="forex" />
                    <LinkTab sx={texter} icon={<PiAirplaneInFlightThin style={{fontSize:"40px"}}/>} label="Charter Flight" value="charter" />
                </TabList>
            </Box>
            </TabContext>
            </Container>
            </div>
            <div className='appbar-mob'>
                <div style={navbar2}>
                    <Box
                    display='flex'
                    sx={{justifyContent:'space-evenly', flexWrap:'wrap', gap:'2vw 8vw', padding:'10px 0', margin:'0 auto'}}
                    >
                        <div>
                            <div className='icon-mob'>
                                <LiaPlaneDepartureSolid style={{fontSize:'2.5rem'}}></LiaPlaneDepartureSolid>
                            </div>
                            <Typography
                            variant='body2'
                            fontWeight='bold'
                            fontSize='12px'
                            textAlign='center'
                            onClick={handleMobNav} 
                            id='/mob/flight'
                            >Flights</Typography>
                        </div>
                        <div>
                            <div className='icon-mob'>
                                <HiOutlineBuildingOffice2 style={{fontSize:'2.5rem'}}></HiOutlineBuildingOffice2>
                            </div>
                            <Typography
                            variant='body2'
                            fontWeight='bold'
                            fontSize='12px'
                            textAlign='center'
                            onClick={handleMobNav} 
                            id='/mob/hotel'
                            >Hotels</Typography>
                        </div>
                        <div>
                            <div className='icon-mob'>
                                <HiOutlineHomeModern style={{fontSize:'2.5rem'}}></HiOutlineHomeModern>
                            </div>
                            <Typography
                            variant='body2'
                            fontWeight='bold'
                            fontSize='12px'
                            textAlign='center'
                            textOverflow='break-word'
                            onClick={handleMobNav} 
                            id='/mob/home'
                            >Home<br />Stays</Typography>
                        </div>
                        <div>
                            <div className='icon-mob'>
                                <PiParachuteFill style={{fontSize:'2.5rem'}}></PiParachuteFill>
                            </div>
                            <Typography
                            variant='body2'
                            fontWeight='bold'
                            fontSize='12px'
                            textAlign='center'
                            onClick={handleMobNav} 
                            id='/mob/holiday'
                            >Holidays</Typography>
                        </div>
                        <div>
                            <div className='icon-mob'>
                                <IoIosTrain style={{fontSize:'2.5rem'}}></IoIosTrain>
                            </div>
                            <Typography
                            variant='body2'
                            fontWeight='bold'
                            fontSize='12px'
                            textAlign='center'
                            onClick={handleMobNav} 
                            id='/mob/train'
                            >Trains</Typography>
                        </div>
                        <div>
                            <div className='icon-mob'>
                                <IoBusOutline style={{fontSize:'2.5rem'}}></IoBusOutline>
                            </div>
                            <Typography
                            variant='body2'
                            fontWeight='bold'
                            fontSize='12px'
                            textAlign='center'
                            onClick={handleMobNav} 
                            id='/mob/bus'
                            >Buses</Typography>
                        </div>
                        <div>
                            <div className='icon-mob'>
                                <AiFillCar style={{fontSize:'2.5rem'}}></AiFillCar>
                                
                            </div>
                            <Typography
                            variant='body2'
                            fontWeight='bold'
                            fontSize='12px'
                            textAlign='center'
                            onClick={handleMobNav} 
                            id='/mob/cab'
                            >Cabs</Typography>
                        </div>
                        <div>
                            <div className='icon-mob'>
                                <BsCashCoin style={{fontSize:'2.5rem'}}></BsCashCoin>
                            </div>
                            <Typography
                            variant='body2'
                            fontWeight='bold'
                            fontSize='12px'
                            textAlign='center'
                            onClick={handleMobNav} 
                            id='/forexs'
                            >Forex</Typography>
                        </div>
                    </Box>
                </div>
            </div>
        </>
  )
}
